import { render, staticRenderFns } from "./SideDrawerMinutes.vue?vue&type=template&id=3c3bcd36&"
import script from "./SideDrawerMinutes.vue?vue&type=script&lang=js&"
export * from "./SideDrawerMinutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports